import { commonRequest } from "../../services/ApiCall";
import { Helpers } from "../../services/Helpers";

export const DeepLinkServices = {
    getDeepUrls: async () => {
        return await commonRequest("GET", `${Helpers.URL()}/api/admin/deep-url/list`, {}, Helpers.token());
    },

    storeDeepUrl: async (fullUrl) => {
        return await commonRequest("POST", `${Helpers.URL()}/api/admin/deep-url/store`, { full_url: fullUrl }, Helpers.token());
    },

    // Get all categories
    getCategories: async () => {
        return await commonRequest("GET", `${Helpers.URL()}/api/admin/service-category/getCategories`, {}, Helpers.token());
    },

    // Get subcategories by category ID
    getSubcategoriesByCategoryId: async (categoryId) => {
        return await commonRequest("GET", `${Helpers.URL()}/api/admin/service-category/getSubCategories/${categoryId}`, {}, Helpers.token());
    },

    // Get services by subcategory ID
    getServicesBySubcategory: async (subCategoryId) => {
        return await commonRequest("GET", `${Helpers.URL()}/api/v2/admin/service-master/getServicesBySubcategory/${subCategoryId}`, {}, Helpers.token());
    },

    // Get child services by master service ID
    getChildServicesByMasterService: async (masterServiceId) => {
        return await commonRequest("GET", `${Helpers.URL()}/api/v2/admin/service-master/getChildServices/${masterServiceId}`, {}, Helpers.token());
    },

    // Get all providers/experts with pagination
    getProviders: async (params = {}) => {
        const queryParams = {
            page: params.page || 1,
            limit: params.limit || 100,
            searchKey: params.searchKey || '',
            sortKey: params.sortKey || '',
            sortDirection: params.sortDirection || '',
        };
        const queryString = new URLSearchParams(queryParams).toString();
        return await commonRequest("GET", `${Helpers.URL()}/api/v2/admin/experts/expert-list?${queryString}`, {}, Helpers.token());
    },

    // Get all bookings with pagination
    getBookings: async (params = {}) => {
        const queryParams = {
            page: params.page || 1,
            limit: params.limit || 100,
            searchKey: params.searchKey || '',
        };
        const queryString = new URLSearchParams(queryParams).toString();
        return await commonRequest("GET", `${Helpers.URL()}/api/admin/service-booking/list?${queryString}`, {}, Helpers.token());
    },

    // Search providers
    searchProviders: async (searchTerm) => {
        return await commonRequest("GET", `${Helpers.URL()}/api/v2/admin/experts/expert-list?searchKey=${searchTerm}&limit=50`, {}, Helpers.token());
    },

    // Search bookings
    searchBookings: async (searchTerm) => {
        return await commonRequest("GET", `${Helpers.URL()}/api/admin/service-booking/list?searchKey=${searchTerm}&limit=50`, {}, Helpers.token());
    }
};
